import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import './styles/GlobalStyles.css';

// Lazy load page components
const Home = lazy(() => import('./pages/Home'));
const Services = lazy(() => import('./pages/Services'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogDetail = lazy(() => import('./pages/BlogDetail'));

// Loading fallback
const PageLoader = () => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    width: '100%',
    backgroundColor: '#000',
    color: '#880000',
    fontSize: '1.5rem',
    fontWeight: '600'
  }}>
    <div>
      <div style={{ marginBottom: '1rem', textAlign: 'center' }}>Loading...</div>
      <div style={{ 
        width: '50px', 
        height: '2px', 
        backgroundColor: '#880000',
        margin: '0 auto',
        animation: 'loading 1.5s infinite'
      }}></div>
      <style jsx>{`
        @keyframes loading {
          0% { width: 0; }
          50% { width: 100px; }
          100% { width: 0; }
        }
      `}</style>
    </div>
  </div>
);

function App() {
  return (
    <Router>
      <Layout>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
          </Routes>
        </Suspense>
      </Layout>
    </Router>
  );
}

export default App;
